import type { PlaneSpec, HiwNotifSpec } from "./types";

/* ── Timeline constants ── */
export const PHASE_TIMES = {
  chaosStart: 0,
  chaosEnd: 1.0,
  filterStart: 1.0,
  filterEnd: 2.0,
  revealStart: 2.0,
  revealEnd: 3.0,
  dwellEnd: 3.4,
  landStart: 3.4,
  landEnd: 4.4,
  applyStart: 4.4,
  applyEnd: 7.2,
  total: 7.2,
} as const;

export const PX_PER_UNIT = 900;

/* ── HIW plane specs by region ── */
export const HIW_PLANES: Record<string, PlaneSpec[]> = {
  AU: [
    { id: 0, label: "GP \u00b7 Parramatta \u00b7 12km \u00b7 A$280/hr", match: true },
    { id: 1, label: "Locum GP \u00b7 Bondi \u00b7 5km", match: true },
    { id: 2, label: "Reg \u00b7 Sydney CBD \u00b7 \u226420km", match: true },
    { id: 3, label: "GP \u00b7 8km \u00b7 A$300/hr", match: true },
    { id: 4, label: "NSW Health \u00b7 GP \u00b7 day", match: true },
    { id: 5, label: "ED \u00b7 Perth \u00b7 3,200km", match: false },
    { id: 6, label: "Band 6 \u00b7 NHS \u00b7 Leeds", match: false },
    { id: 7, label: "ICU Reg \u00b7 night shift", match: false },
  ],
  UAE: [
    { id: 0, label: "GP \u00b7 Dubai Marina \u00b7 5km \u00b7 AED 500/hr", match: true },
    { id: 1, label: "Locum GP \u00b7 JBR \u00b7 3km", match: true },
    { id: 2, label: "Reg \u00b7 Abu Dhabi \u00b7 \u226415km", match: true },
    { id: 3, label: "GP \u00b7 6km \u00b7 AED 550/hr", match: true },
    { id: 4, label: "DHA \u00b7 GP \u00b7 day", match: true },
    { id: 5, label: "ED \u00b7 Fujairah \u00b7 180km", match: false },
    { id: 6, label: "Band 6 \u00b7 NHS \u00b7 Leeds", match: false },
    { id: 7, label: "ICU Reg \u00b7 night shift", match: false },
  ],
  UAE_AR: [
    { id: 0, label: "طبيب عام · دبي مارينا · ٥ كم · ٥٠٠ د.إ/ساعة", match: true },
    { id: 1, label: "طبيب عام مؤقت · JBR · ٣ كم", match: true },
    { id: 2, label: "مسجل · أبوظبي · ≤١٥ كم", match: true },
    { id: 3, label: "طبيب عام · ٦ كم · ٥٥٠ د.إ/ساعة", match: true },
    { id: 4, label: "DHA · طبيب عام · نهاري", match: true },
    { id: 5, label: "طوارئ · الفجيرة · ١٨٠ كم", match: false },
    { id: 6, label: "Band 6 · NHS · ليدز", match: false },
    { id: 7, label: "مسجل عناية مركزة · ليلي", match: false },
  ],
};

/* ── HIW notification specs by region ── */
export const HIW_NOTIFS: Record<string, HiwNotifSpec[]> = {
  AU: [
    { id: 0, kind: "call", sender: "CC Medical", text: "Incoming call \u00b7 Perth ED" },
    { id: 1, kind: "whatsapp", sender: "Ochre Health", text: "Rural GP \u00b7 500km \u00b7 tonight?" },
    { id: 2, kind: "sms", sender: "NSW Health", text: "URGENT: Band 5 nights, 200km" },
    { id: 3, kind: "whatsapp", sender: "Cornerstone Med", text: "Darwin A$350/hr \u2014 pls reply" },
    { id: 4, kind: "call", sender: "Unknown", text: "Missed call \u00b7 11:42" },
    { id: 5, kind: "sms", sender: "Medacs", text: "Last-minute cover needed!!!" },
  ],
  UAE: [
    { id: 0, kind: "call", sender: "Medacs Healthcare", text: "Incoming call \u00b7 Sharjah ED" },
    { id: 1, kind: "whatsapp", sender: "MSI Group", text: "Al Ain GP \u00b7 150km \u00b7 tonight?" },
    { id: 2, kind: "sms", sender: "DHA Staffing", text: "URGENT: ICU nights, Mediclinic" },
    { id: 3, kind: "whatsapp", sender: "Globe Locums", text: "Fujairah AED 650/hr \u2014 pls reply" },
    { id: 4, kind: "call", sender: "Unknown", text: "Missed call \u00b7 11:42" },
    { id: 5, kind: "sms", sender: "NMC Recruitment", text: "Last-minute cover needed!!!" },
  ],
  UAE_AR: [
    { id: 0, kind: "call", sender: "ميداكس هيلثكير", text: "مكالمة واردة · طوارئ الشارقة" },
    { id: 1, kind: "whatsapp", sender: "MSI جروب", text: "طبيب عام العين · ١٥٠ كم · الليلة؟" },
    { id: 2, kind: "sms", sender: "توظيف DHA", text: "عاجل: ليالي عناية مركزة، ميديكلينيك" },
    { id: 3, kind: "whatsapp", sender: "غلوب لوكمز", text: "الفجيرة ٦٥٠ د.إ/ساعة — رد من فضلك" },
    { id: 4, kind: "call", sender: "مجهول", text: "مكالمة فائتة · ١١:٤٢" },
    { id: 5, kind: "sms", sender: "توظيف NMC", text: "تغطية مطلوبة فوراً!!!" },
  ],
};
